import { alpha } from '@mui/material/styles';
import { UI } from './constants';

// ----------------------------------------------------------------------
// Shared style objects
// ----------------------------------------------------------------------
export const gradientButtonSx = {
  width: '100%',
  height: 52,
  borderRadius: 2,
  fontWeight: 800,
  fontSize: 15,
  textTransform: 'none',
  color: '#0A0B08',
  background: UI.gradient,
  boxShadow: 'none',
  '&:hover': { background: UI.gradient, filter: 'brightness(1.05)', boxShadow: 'none' },
  '&.Mui-disabled': { background: 'rgba(255,255,255,0.07)', color: UI.textFaint },
};

export const fieldBoxSx = {
  borderRadius: 2,
  border: `1px solid ${UI.border}`,
  bgcolor: 'rgba(255,255,255,0.02)',
  px: 1.75,
  py: 1.5,
};

export const cardSx = {
  width: '100%',
  minHeight: '600px',
  borderRadius: 3,
  p: { xs: 2, sm: 2.5 },
  bgcolor: UI.panel,
  border: `1px solid ${alpha(UI.green, 0.5)}`,
  boxShadow: `0 24px 70px rgba(0,0,0,0.55), 0 0 0 1px ${alpha(UI.green, 0.08)}, 0 0 40px ${alpha(UI.green, 0.12)}`,
};

export const menuPaperProps = {
  sx: {
    mt: 1,
    minWidth: 210,
    bgcolor: UI.panel,
    color: UI.text,
    border: `1px solid ${UI.border}`,
    borderRadius: 2,
    '& .MuiMenuItem-root': {
      fontSize: 14,
      '&:hover': { bgcolor: 'rgba(255,255,255,0.06)' },
    },
  },
};

export function getTabSx(isActive) {
  const base = {
    flex: 1,
    textAlign: 'center',
    py: 1,
    px: 2,
    borderRadius: 1.5,
    fontSize: 14,
    fontWeight: 600,
    cursor: 'pointer',
    userSelect: 'none',
    transition: 'all 0.15s ease',
  };

  if (isActive) {
    return {
      ...base,
      bgcolor: 'primary.main',
      color: 'common.white',
      boxShadow: '0 2px 8px rgba(0,0,0,0.25)',
    };
  }

  return {
    ...base,
    color: 'rgba(255,255,255,0.55)',
    '&:hover': {
      color: 'rgba(255,255,255,0.9)',
      bgcolor: 'rgba(255,255,255,0.04)',
    },
  };
}

export function getSegmentSx(isActive) {
  const base = {
    px: 1.5,
    py: 0.75,
    borderRadius: 1.25,
    cursor: 'pointer',
    fontSize: 12.5,
    fontWeight: 700,
    userSelect: 'none',
  };
  if (isActive) return { ...base, bgcolor: 'rgba(255,255,255,0.08)', color: UI.text };
  return { ...base, bgcolor: 'transparent', color: UI.textMuted };
}
